<template>
  <h1 class="adv-title">&nbsp;<slot></slot>&nbsp;</h1>
</template>

<script>
export default {
  name: "adv-title",
};
</script>

<style lang="less">
.adv-title {
  font-style: italic;
  margin-bottom: 28px;
  text-transform: uppercase;

  &::before {
    font-style: normal;
    font-weight: bold;
    content: "[ ";
  }

  &::after {
    font-style: normal;
    font-weight: bold;
    content: " ]";
  }
}
</style>
